import { withPlaceholder } from '../../Placeholders';
import { SingleRowPlaceholder } from '../../Placeholders/Templates';
import { Typography } from '..';

export default withPlaceholder({
    customPlaceholder: SingleRowPlaceholder
})(Typography);
